import { API } from "../store"
import handleCatch from "../lib/catch"

export const getCrewDealMemo = uniqueString => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/billing/get-deal-memo/${uniqueString}`)
          .then(response => response.body)
          .then(response => {
            resolve(response.data)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getClientDealMemo = uniqueString => {
  let clientData = {
    for_client: true,
  }
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/billing/get-deal-memo/${uniqueString}`)
          .send(clientData)
          .then(response => response.body)
          .then(response => {
            resolve(response.data)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const recallInvoiceForClient = (data) => ({
  type: "RECALL::INVOICE_FOR_CLIENT",
  data
})


export const createCrewAdditionalExpense = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/billing/shoots/deal-memo/additional-item`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateFlagStatusCrewClient = (flagData, itemId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/shoots/deal-memo/item-status/${itemId}`)
          .send(flagData)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateCrewAdditionalExpense = (data, additionalItemId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/shoots/deal-memo/additional-item/${additionalItemId}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const deleteCrewAdditionalExpense = additionalExpenseId => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(
          `/billing/shoots/deal-memo/additional-item/${additionalExpenseId}`
        )
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

// accept or reject on Crew Deal Memo page, approve on Crew Bill page
export const updateCrewDealMemoStatus = (data, shootRoleId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/shoots/deal-memo/${shootRoleId}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateClientEstimateInvoiceStatus = (actionData, shootId) => {
  let { url_type } = actionData
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/shoots/deal-memo/${url_type}/${shootId}`)
          .send(actionData)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}
